import { filterObject } from 'legacy/utils/filterObject'
import { toLanesQueryString } from 'legacy/utils/toLanesQueryString'

import { parseLanesQueryString } from './parseLanesQueryString'

const STOP_PROPS_BLACKLIST = ['description']

function sanitizeLaneStop(stop) {
  return filterObject(stop, someProp => !STOP_PROPS_BLACKLIST.includes(someProp))
}

function sanitizeLanesQueryString(lanesStr) {
  const lanes = parseLanesQueryString(lanesStr)

  const sanitized = lanes.map(someLane => ({
    ...someLane,
    pickup: sanitizeLaneStop(someLane.pickup),
    delivery: sanitizeLaneStop(someLane.delivery),
  }))

  return toLanesQueryString(sanitized, {
    fragment: ',',
  })
}

export { sanitizeLanesQueryString }
